import type { IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createHook, type Action } from '@atlassian/react-sweet-state';

export type State = {
	hoveredIssueKey: IssueKey | null;
};

export const initialState: State = {
	hoveredIssueKey: null,
};

export const actions = {
	setHoveredIssueKey:
		(issueKey: IssueKey | null): Action<State> =>
		({ setState }) =>
			setState({
				hoveredIssueKey: issueKey,
			}),
} as const;

type Actions = typeof actions;

const Store = createStore<State, Actions>({
	name: 'hoveredIssueKey',
	initialState,
	actions,
});

export const useHoveredIssueKey = createHook(Store, {
	selector: (state) => state.hoveredIssueKey,
});
